// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.favorite-icon-btn-JkKqYz{justify-content:center;align-items:center;width:100%;height:100%;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"favorite-icon-btn": `favorite-icon-btn-JkKqYz`,
	"favoriteIconBtn": `favorite-icon-btn-JkKqYz`
};
export default ___CSS_LOADER_EXPORT___;
